export default "__VITE_PUBLIC_ASSET__b9cf68a1__"